import type { FC } from 'react';
import { MultiplesGeneratorContext } from '../model/MultiplesGeneratorModel';
import { useMultiplesGenerator } from '../model/useMultiplesGenerator';
import { NumberDetail } from './NumberDetail';
import { RegenerateControls } from './RegenerateControls';

interface Props {
  baseNumber: number;
}

/**
 * "Root" component that attaches the model hook and provides it via context to subcomponents
 *
 * Hint: you can use the advantage of modularity of hooks and if you need to intercept the hook
 * somehow in ancestor components, just rewrite your root component to receive the hook via props.
 */
export const MultiplesGenerator: FC<Props> = (props) => {
  const model = useMultiplesGenerator(props.baseNumber);

  return (
    <MultiplesGeneratorContext.Provider value={model}>
      <NumberDetail />
      <RegenerateControls />
    </MultiplesGeneratorContext.Provider>
  );
};
